<template>
    <div class="w-full">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-y-8 gap-x-8">
            <div>
                <label class="block text-sm mb-1 font-bold">&nbsp;</label>

                <label class="block text-sm mb-1 font-bold" for="current-email">
                    Current Email
                </label>
                <div
                    id="current-email"
                    class="block text-sm mb-5"
                    name="current_email"
                    required
                    autocomplete="current-email"
                >
                    {{ userSettings.email }}
                </div>
            </div>
            <div>
                <label
                    v-if="changing"
                    class="block text-sm mb-1 font-bold"
                    for="current-email"
                >
                    New Email Address
                </label>
                <div
                    v-if="changing"
                    class="form-input p-0 mb-1"
                >
                    <input
                        id="current-email"
                        type="email"
                        class="form-input w-11/12 pl-2 border-0 shadow-none inline"
                        name="current_email"
                        required
                        autocomplete="current-email"
                        v-model="newEmailAddress"
                    />
                </div>
            </div>
            <div class="flex justify-start lg:justify-end">
                <div>
                    <label class="block text-sm mb-1 font-bold">&nbsp;</label>
                    <ActionButton
                        v-if="changing"
                        :disabled="loading"
                        @clicked="doChangeEmail"
                        label="Send Verification Email"
                        classes="btn bg-navy-500 hover:bg-navy-400 text-white"
                    />
                    <button
                        v-if="!changing"
                        type="button"
                        class="btn bg-navy-500 hover:bg-navy-400 text-white !mt-3"
                        @click="changing = true"
                    >
                        Change Email Address
                    </button>
                </div>
            </div>
            <!-- row -->
            <div></div>
            <div>
                <label
                    v-if="changing"
                    class="block text-sm mb-1 font-bold"
                    for="confirm-email"
                >
                    Confirm Email Address
                </label>
                <div
                    v-if="changing"
                    class="form-input p-0 mb-5"
                >
                    <input
                        id="confirm-email"
                        type="email"
                        class="form-input w-11/12 pl-2 border-0 shadow-none inline"
                        name="confirm_email"
                        required
                        autocomplete="confirm-email"
                        v-model="confirmEmail"
                    />
                </div>
                <Errors :errors="errors"/>
            </div>
            <div>
                <div v-if="loading" class="flex items-center gap-2">
                    <Icon icon="loader" size="small" />
                    <span>Sending verification email...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Auth from '@/services/auth';
import ActionButton from '../action-button.vue';
import Errors from '@/components/errors.vue';
import { useAppStore } from '@/store/app';
import { mapState } from 'pinia';
import { notify } from 'notiwind';
import Icon from '../ui/icon/icon.vue';


export default {
    components: {
        Icon,
        ActionButton,
        Errors
    },
    data() {
        return {
            form: {
                email: ''
            },
            errors: [],
            loading: false,
            changing: false,
            newEmailAddress: '',
            confirmEmail: '',
        };
    },
    methods: {
        async doChangeEmail() {
            if (this.validateEmail() === false) {
                return;
            }
            this.loading = true;
            try {
                Auth.updateUser({
                    email: this.newEmailAddress,
                    name: this.userSettings.name,
                }).then(result => {
                    console.log("success");
                    this.userSettings.email = this.newEmailAddress;
                    this.userSettings.email_verified = false;
                    this.newEmailAddress = '';
                    this.confirmEmail = '';
                    this.changing = false;
                    this.loading = false;
                    // toast
                    notify(
                        {
                            group: 'success',
                            title: 'Email Change',
                            text: 'We\'ve sent a verification link to your new email address. Please click the link in the email to confirm the change before logging in with your new email address.',
                        },
                        4000
                    );
                }).catch(error => {
                    notify(
                        {
                            group: 'error',
                            title: 'Email Change',
                            text: 'Error sending verification email',
                        },
                        4000
                    );
                });
                console.log("Request send");
                this.loading = false;
            } catch (error) {
                this.errors = error.response.data.errors;
                console.log("Request failed");
                this.loading = false;
            }
        },
        validateEmail() {
            this.errors = [];
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.newEmailAddress)) {
                this.errors.push({ message: 'Email address is invalid' });
            }
            if (this.newEmailAddress === this.userSettings.email) {
                this.errors.push({ message: 'Email address should be different than current mail address' });
            }
            if (this.newEmailAddress !== this.confirmEmail) {
                this.errors.push({ message: 'Email addresses do not match' });
            }
            if (this.errors.length > 0) {
                return false;
            }
        },
    },
    computed: {
        ...mapState(useAppStore, ['userSettings']),
    },
}
</script>

<style scoped lang="scss">

</style>
